
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29 7.51v12.364a.785.785 0 01-1.57 0V7.51a.942.942 0 00-.94-.942H9.825a.942.942 0 00-.941.942v1.805h13.76a2.043 2.043 0 012.04 2.04v2.925H13.819a3.744 3.744 0 100 7.488h10.865v2.907a2.04 2.04 0 01-2.04 2.04H5.04A2.04 2.04 0 013 24.676v-13.32a2.043 2.043 0 012.04-2.04h2.276V7.51A2.51 2.51 0 019.826 5H26.49A2.51 2.51 0 0129 7.51zm-15.181 8.34h10.865v4.335H13.82a2.175 2.175 0 010-4.35v.015zm.022 1.39a.785.785 0 100 1.57h2.51a.785.785 0 000-1.57h-2.51z","fill":"#737791"}})])
          )
        }
      }
    